<template>
  <div class="result">
    <Close v-show="stage === stages.failure"/>
    <template v-if="stage === stages.unknown">
      <div class="result__icon" :class="{unknown:stage === stages.unknown}">
        <Loading type="circular" color="#F16622" size="50px"/>
      </div>
      <div class="result__title">
        {{ displayContent.title }}
      </div>
      <div
          class="result__message"
      >
        {{ displayContent.message }}
      </div>
    </template>
    <template v-if="stage===stages.failure">
      <div class="result__icon">
        <SvgIcon
            :icon-class="iconClass"
            width="250"
            height="250"
        />
      </div>

      <div
          :style="titleStyles"
          class="result__title"
      >
        {{ title }}
      </div>

      <div
          v-if="stage === stages.failure"
          class="result__message"
      >
        {{ serverErrorMessage }}
      </div>

      <div class="result__message">{{ resultMessage }}</div>
      <div class="result__buttons" v-if="bindingCard">
        <van-button
            @click="handleBindingRetry"
            type="primary"
            class="result__buttons__button"
        >
          {{ $t('result.buttons.tryAgain') }}
        </van-button>
        <van-button
            @click="handleBindingDismiss"
            class="result__buttons__button dismiss"
        >
          {{ $t('result.buttons.dismiss') }}
        </van-button>
      </div>
      <div class="result__buttons" v-else>
        <van-button
            v-if="stage === stages.success"
            @click="handleDismiss"
            type="primary"
            class="result__buttons__button"
        >
          {{ $t('result.closeThisWindow') }}
        </van-button>
        <template v-else>
          <van-button
              @click="handleDismiss"
              type="primary"
              class="result__buttons__button"
          >
            {{ $t('result.buttons.dismiss') }}
          </van-button>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
import { queryPay, queryBinding } from '@/api'
import { Loading } from 'vant'
import Close from '@/components/Close'
import { loadingScreen, failureScreen } from '@/utils/screen'
import { postMessage, types } from '@hll/cashier-kit'
import { mapGetters } from 'vuex'
import PaymentSelectList from '@/pages/PaymentSelectList'
import { get } from 'lodash-es'
import { getEvokePolicy } from '@/utils/localstorage-provider'
import { getSearchParams } from '@/utils'

const stages = {
  unknown: 'unknown',
  timeout: 'timeout',
  success: 'success',
  failure: 'failure'
}

export default {
  name: 'Result',
  components: { Close, SvgIcon, Loading },
  props: {
    type: {
      type: String,
      validator: val =>
        [stages.unknown, stages.success, stages.failure].includes(val)
    },
    payToken: {
      type: String,
      default: ''
    },
    isWalletPayment: {
      type: Boolean,
      default: false
    }
  },
  created () {
    if (getSearchParams().bindingCard === '1') {
      return postMessage({ action: 'cashierOffSelf', status: 1 })
    }
    if (this.type === stages.unknown) {
      postMessage({ action: 'processing', status: 1 })
      if (this.thirdParty) {
        window.onmessage = ev => {
          const { data } = ev
          const { action, status } = data
          if (action === 'cashierOffSelf') {
            switch (status) {
              case 2:
                postMessage({ action: 'processing', status })
                postMessage({ action: 'cashierOff', status })
                window.thirdPartyWin.close()
                window.thirdPartyWin = null
                break
              case 1:
                if (!this.bindingCard) {
                  postMessage({ action: 'processing', status: 2 })
                  this.$emit('goTo', { component: PaymentSelectList.name })
                } else {
                  this.$emit('goTo', { component: 'Result', type: 'unknown' })
                  this.loopQueryPay()
                }
                window.thirdPartyWin.close()
                window.thirdPartyWin = null
            }
          }
        }
        this.TPWTimer = setInterval(() => {
          if (window?.thirdPartyWin?.closed) {
            clearInterval(this.TPWTimer)
            if (this.bindingCard) {
              queryBinding({ payToken: this.payToken }).then(res => {
                const { status: paySuccess } = res.data
                if (paySuccess === 2) {
                  postMessage({ action: 'processing', status: 2 })
                  postMessage({ action: 'cashierOff', status: 2 })
                } else {
                  postMessage({ action: 'cashierOff', status: 1 })
                }
              })
            } else {
              queryPay({ payToken: this.payToken }).then(res => {
                const { status: paySuccess } = res.data
                if (paySuccess === 2) {
                  postMessage({ action: 'processing', status: 2 })
                  postMessage({ action: 'cashierOff', status: 2 })
                } else {
                  this.$emit('goTo', { component: PaymentSelectList.name })
                }
              })
            }
          }
        }, 500)
        return
      }
      this.loopQueryPay({ interval: 5000 })
      return
    }
    this.stage = this.type
  },
  data () {
    return {
      stages,
      stage: stages.unknown,
      timer: '',
      serverErrorMessage: '',
      retries: 0,
      // 监听打开window计时器
      TPWTimer: '',
      maxRetries: 6,
      purposeType: '1'
    }
  },
  methods: {
    loopQueryPay ({ interval = 5000 } = {}) {
      const evokePolicy = getEvokePolicy()

      if (this.timer) return
      this.maxRetries = evokePolicy.times || 12
      // this.maxRetries = 1
      this.timer = setInterval(this.looper, evokePolicy.interval || interval)
    },
    looper () {
      if (this.bindingCard) {
        return queryBinding({ payToken: this.payToken }).then(
          res => {
            if (parseInt(res.data.status) === 2) { // status can be 2 or "2"
              this.stage = stages.success
              postMessage({ action: 'cashierOff', status: 2 })
              this.stopLoop()
              return
            }

            this.retries++
            if (this.retries > this.maxRetries) {
              this.stage = stages.failure
              this.stopLoop()
              postMessage({ action: 'processing', status: 2 })
            }
          },
          reject => {
            this.serverErrorMessage = `Error: ${reject.data.ret} - ${reject.data.msg}`
            this.stage = stages.failure
            postMessage({ action: 'processing', status: 2 })
            this.stopLoop()
          }
        )
      } else {
        queryPay({ payToken: this.payToken }).then(
          res => {
            this.purposeType = res.data.purposeType
            if (parseInt(res.data.status) === 2) { // status can be 2 or "2"
              this.stage = stages.success
              postMessage({ action: 'cashierOff', status: 2 })
              this.stopLoop()
              return
            }

            this.retries++
            if (this.retries > this.maxRetries) {
              this.stage = stages.failure
              this.stopLoop()
              postMessage({ action: 'processing', status: 2 })
            }
          },
          reject => {
            this.serverErrorMessage = `Error: ${reject.data.ret} - ${reject.data.msg}`
            this.stage = stages.failure
            postMessage({ action: 'processing', status: 2 })
            this.stopLoop()
          }
        )
      }
    },
    stopLoop () {
      clearInterval(this.timer)
      this.timer = ''
    },
    handleDismiss () {
      const message = {
        action: 'cashierOffSelf',
        status: this.stage === stages.success ? 2 : 3
      }
      postMessage(message)
      postMessage({ action: 'cashierOff', status: 3 })
    },
    handleBindingRetry () {
      postMessage({ action: 'rebindingCard' })
    },
    handleBindingDismiss () {
      postMessage({ action: 'bindingCardOff' })
    }
  },
  computed: {
    ...mapGetters([types.COMPONENT_STATUS, types.ORDER_INFO]),
    thirdParty () {
      return this[types.COMPONENT_STATUS].thirdParty
    },
    duplicated () {
      return this[types.COMPONENT_STATUS].duplicated
    },
    hcountry () {
      return get(this, `[${types.ORDER_INFO}].orderInfo.hcountry`)
    },
    iconClass () {
      const classes = {
        success: 'success-icon',
        failure: 'error-icon'
      }
      return classes[this.stage] || 'error-icon'
    },
    titleStyles () {
      const colors = {
        [stages.success]: '#303030',
        [stages.failure]: '#303030'
      }
      return { color: colors[this.stage] }
    },
    title () {
      const keys = {
        [stages.timeout]: 'noResultHeading',
        [stages.success]: 'paymentSuccess',
        [stages.failure]: this.purposeType === '1' ? 'paymentFailed' : 'topUpFailed'
      }
      if (this.bindingCard) {
        keys[stages.failure] = 'failedToAdd'
      }
      if (this.bindingCard && this.duplicated) {
        keys[stages.failure] = 'alreadyAdded'
      }
      return this.$t(`result.${keys[this.stage]}`)
    },
    resultMessage () {
      const keys = {
        [stages.timeout]: 'noResultMessage',
        [stages.success]: 'paymentSuccessMessage',
        [stages.failure]: this.purposeType === '1' ? 'paymentFailedMessage' : 'topUpFailedMessage'
      }
      if (this.bindingCard) {
        keys[stages.failure] = 'failedToAddHint'
      }
      if (this.bindingCard && this.duplicated) {
        keys[stages.failure] = 'alreadyAddedHint'
      }
      return this.$t(`result.${keys[this.stage]}`)
    },
    ovo () {
      return this[types.COMPONENT_STATUS].ovo
    },
    bindingCard () {
      const { bindingCard, type } = getSearchParams()
      return this[types.COMPONENT_STATUS].bindingCard || bindingCard || type === 'bindingcard'
    },
    displayContent () {
      if (this.thirdParty) {
        return {
          title: this.$t('result.thirdPartyWindowTitle'),
          message: this.$t('result.thirdPartyWindowHint')
        }
      }
      if (this.ovo) {
        return {
          title: this.$t('ovo.processingPayment'),
          message: this.$t('ovo.processingHint')
        }
      }
      return {
        title: this.bindingCard ? this.$t('result.verifyingPayment') : this.$t('result.processingPayment'),
        message: this.$t('result.processingPaymentHint')
      }
    }
  },
  watch: {
    stage: {
      immediate: true,
      handler (val) {
        switch (val) {
          case stages.failure:
            if (this.bindingCard) {
              return postMessage({ action: 'resizeParent', width: 480, height: 535 })
            }
            failureScreen()
            break
          case stages.unknown:
            loadingScreen()
            break
          case stages.success:
            postMessage({ action: 'cashierOffSelf', status: 2 })
            break
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.result {
  padding: 0 40px;

  &__icon {
    margin-top: 44px;
    display: flex;
    justify-content: center;

    &.unknown {
      margin-top: 130px;
    }
  }

  &__title {
    margin-top: 20px;
    font-size: 18px;
    text-align: center;
    color: #303030;
    font-weight: 700;
  }

  &__subtitle {
    font-size: 14px;
    text-align: center;
    color: #737373;
    margin-top: 16px;
  }

  &__buttons {
    margin-top: 48px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &__button {
      width: 400px;
      height: 52px;

      &.dismiss {
        border: none;
        background: transparent;
        color: #ff1622;
      }

      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }

  &__message {
    text-align: center;
    margin-right: 50px;
    margin-left: 50px;
    margin-top: 8px;
  }
}
</style>
